// extracted by mini-css-extract-plugin
export var container = "_38-0";
export var error = "_38-9";
export var label = "_38-5";
export var light = "_38-6";
export var md = "_38-3";
export var sm = "_38-2";
export var thin = "_38-8";
export var thinBold = "_38-7";
export var vertical = "_38-4";
export var xs = "_38-1";